import Cookie from 'portal-common-account/src/utils//cookie';

export function getUinAndSkey() {
  const uin = Cookie.get('uin') || '';
  const skey = Cookie.get('skey');
  return {
    uin: uin.replace(/^o0*/, ''),
    skey,
  };
}
